export default async function init() {
  const elements = document.querySelectorAll('[data-reveal]');

  const { default: RevealBox } = await import(/* webpackChunkName: "reveal-box" */ './reveal-box');

  elements.forEach((element) => new RevealBox(element));
}
